export default {
  namespaced: true,

  state: {
    selectedBusiness: null,
  },

  mutations: {
    setSelectedBusiness(state, selectedBusiness) {
      state.selectedBusiness = selectedBusiness;
    },
  },

  getters: {
    selectedBusinessName: state => _.get(state, 'selectedBusiness.businessName', ''),
    selectedBusinessNumber: state => _.get(state, 'selectedBusiness.id', ''),
  },
};
